import PropTypes from 'prop-types'
import { useEffect } from 'react'
import Preview from 'features/creative/preview/Preview'
import LandingUrl from 'features/creative/add/common/LandingUrl'
import { useDispatch, useSelector } from 'react-redux'
import {
  reset,
  setIndividualChecked,
  setMobileUrl,
  setPcUrl,
} from 'features/creative/add/asset/calculateSlice'
import useChannelLandingUrlPolicy from 'features/creative/add/common/useChannalLandingUrlPolicy'
import Button from 'components/form/Button'
import { inactiveAsset } from 'features/creative/add/build/buildCreativeSlice'

const Calculate = ({ disabled, errors, imported }) => {
  const dispatch = useDispatch()
  const {
    landingUrl: { individual, mobileUrl, pcUrl },
  } = useSelector(state => state.creative.assets.calculate)

  useEffect(
    () => () => {
      dispatch(reset())
    },
    [dispatch]
  )
  useChannelLandingUrlPolicy(v => setIndividualChecked(v), disabled, imported)

  const onChangePcUrl = v => {
    dispatch(setPcUrl(v))
  }
  const onChangeMobileUrl = v => {
    dispatch(setMobileUrl(v))
  }
  const onChangeIndividual = v => {
    dispatch(setIndividualChecked(v))
  }

  return (
    <div className="cont_material">
      <div className="group_material">
        <div className="box_material">
          <strong className="subtit_subject2">
            버튼형 &gt; 계산하기
            <Button
              size="small"
              disabled={disabled}
              onClick={() => {
                dispatch(inactiveAsset('calculate'))
              }}>
              삭제
            </Button>
          </strong>
          <div className="inner_material">
            <LandingUrl
              individual={individual}
              mobileUrl={mobileUrl}
              pcUrl={pcUrl}
              onChangeIndividual={onChangeIndividual}
              onChangeMobileUrl={onChangeMobileUrl}
              onChangePcUrl={onChangePcUrl}
              disabled={disabled}
              errors={{ mobileUrl: errors?.mobileUrl, pcUrl: errors?.pcUrl }}
            />
          </div>
        </div>
        <Preview type="CALCULATE" />
      </div>
    </div>
  )
}

export default Calculate

Calculate.propTypes = {
  disabled: PropTypes.bool.isRequired,
  errors: PropTypes.object,
  imported: PropTypes.bool,
}
